export default {"src":"/_next/static/media/ccs-combo-2.8ade11a3.svg","height":40,"width":33,"blurWidth":0,"blurHeight":0};